import React from "react";
import { Box } from "@mui/material";
import { NormalText } from "../../../../components/TextParts";

export default function HeadInfoListItem({ head, text }) {
  return (
    <Box sx={{ display: { xs: "block", sm: "flex" }, pb: "5px" }}>
      <Box sx={{ width: "120px" }}>
        <NormalText text={head} />
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <NormalText text={text} />
      </Box>
    </Box>
  );
}